// client/open-href.ts
import { A } from "@adornis/base/env-info.js";
import { fromEvent } from "rxjs";
import { filter, skip, take } from "rxjs/operators";
import {
  NO_CHANGE,
  generateFullRoutingStateFromInput,
  generateHrefFromRoutingState,
  routingState
} from "./routing-state.js";
function _goTo(target) {
  let routingInfo;
  if (typeof target === "string") {
    const [p1, p2] = target.split("?");
    const [path, maybeHash1] = p1.split("#");
    const [searchParams, maybeHash2] = p2?.split("#") ?? [];
    const hash = maybeHash1 ?? maybeHash2;
    routingInfo = { path, searchParams, hash };
  } else {
    routingInfo = target;
  }
  if (routingInfo.path && routingInfo.path !== NO_CHANGE && /^http[s]?:\/\//.test(routingInfo.path) && !routingInfo.path.startsWith(window.location.origin)) {
    window.open(generateHrefFromRoutingState(generateFullRoutingStateFromInput(routingInfo)), "_self");
  } else
    routingState.next(routingInfo);
}
function openExternalHref(externalURL, {
  target = "_blank",
  inAppBrowserOptions = "toolbarposition=top,location=no",
  openFeatures
} = {}) {
  if (typeof cordova !== "undefined" && cordova.InAppBrowser) {
    const inAppBrowserRef = cordova.InAppBrowser.open(externalURL, "_blank", inAppBrowserOptions);
    fromEvent(inAppBrowserRef, "loadstart").pipe(
      skip(1),
      filter((e) => e.url.includes(A.absoluteUrl()) && !e.url.includes("/api/")),
      take(1)
    ).subscribe((e) => {
      inAppBrowserRef.close();
      routingState.path = `/${e.url.replace(A.absoluteUrl(), new URLSearchParams({}).toString())}`;
    });
  } else {
    window.open(externalURL, target, openFeatures);
  }
}
function goTo(targetURL, routingOptions = {}) {
  if (!routingOptions.target || routingOptions.target === "_self") {
    return _goTo(targetURL);
  }
  if (typeof targetURL !== "string" && targetURL.path === NO_CHANGE)
    throw new Error("Cannot use path:NO_CHANGE for targets other than _self");
  if (typeof targetURL === "string")
    return openExternalHref(targetURL, routingOptions);
  return openExternalHref(generateHrefFromRoutingState(generateFullRoutingStateFromInput(targetURL)), routingOptions);
}
export {
  goTo
};
